import React, { Component } from 'react';
import { connect } from 'react-redux';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import {getVunnenListPByAfid,setofUpdatedashboard} from 'actions'
import {isEmpty} from 'lodash'
import { withStyles } from '@material-ui/core/styles';
import {NumberFormat} from 'components/NotyNumberFormat'
import Skeleton from '@material-ui/lab/Skeleton';

function mapStateToProps({auth,DashBoard,accountsData}) {
    const { authUser} = auth;
    const { updatedashboard,DashBoardValueOf} = accountsData;
      const { VunnenListP,DashboardProspektFilterOption} = DashBoard;
      return {
          authUser,VunnenListP,DashboardProspektFilterOption,
          updatedashboard,DashBoardValueOf
      };
  }

function mapDispatchToProps(dispatch) {
    return {
        getVunnenListPByAfid: (Afid,userid,FilterOption,isDashBoard) => dispatch(getVunnenListPByAfid(Afid,userid,FilterOption,isDashBoard)),
        setofUpdatedashboard: () => dispatch(setofUpdatedashboard()),
        dispatch
    };
}

const useStyles = theme => ({

    root: {
        '&::-webkit-scrollbar': {
            width: '5px'
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent'
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#12484B',
            outline: '1px solid transparent'
          }
     },
});

const StyledTableRow = withStyles((theme) => ({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: '#12585E',
        // backgroundColor: '#14484D',
      },
    },
  }))(TableRow);

let id = 0;

function createData(name, value,) {
    id += 1;
    return { id, name, value };
}

const data = [
    createData("IKEA", "120K"),
    createData("Volvo", "110K"),
    createData("Skanska", "70K"),
    createData("Vattenfall", "125K"),
    createData("Sandvik", "300K"),
    createData("Preem", "130K"),
    createData("Axfood", "150K"),
];

class OpportunityTable extends Component {
    state={
        VunnenListP:[],
        DashboardProspektFilterOption:parseInt(this.props.Kontor) === 0?[]:[{Meta:"Kontor",Value:this.props.Kontor}],
        done: false
    }
    intervalID = null
    componentDidMount=()=>{
        const Afid = this.props.Afid;
        
        this.props.getVunnenListPByAfid(Afid,undefined,this.state.DashboardProspektFilterOption,this.props.isDashBoard).then(() => { 
            this.initiateInterval()
            this.setState({done: true})
         })
       
    }
    initiateInterval () {
        clearInterval(this.intervalID);
        this.intervalID = null 
        this.intervalID = setInterval(
            () => {
                if(this.state.done === true){ 
                    this.setState({ done:false })
                    const Afid = this.props.Afid;
                    this.props.getVunnenListPByAfid(Afid,undefined,this.state.DashboardProspektFilterOption,this.props.isDashBoard).then(() => { 
                        this.initiateInterval()
                        this.setState({done: true})
                     })
                }
            },
            180000
        );
      }
    componentDidUpdate=()=>{
        const Afid = this.props.Afid;
        if(parseInt(this.props.updatedashboard) === 1){
            this.props.getVunnenListPByAfid(Afid,undefined,this.state.DashboardProspektFilterOption,this.props.isDashBoard).then(() => { 
                this.initiateInterval()
                this.setState({done: true})
             })
             this.props.setofUpdatedashboard()
        }
        if(this.props.DashboardProspektFilterOption !== this.state.DashboardProspektFilterOption && !isEmpty(this.props.DashboardProspektFilterOption))
        {
             
            
            this.props.getVunnenListPByAfid(Afid,undefined,this.state.DashboardProspektFilterOption,this.props.isDashBoard).then(() => { 
                this.initiateInterval()
                this.setState({done: true})
             }) /**/
            this.setState({
                DashboardProspektFilterOption:this.props.DashboardProspektFilterOption 
            }) 
        }
    }
    componentWillUnmount() {
      clearInterval(this.intervalID);
      this.intervalID = null
    }  
    getDashBoardValueOf = ()=>{
        try{
        let ModuleValue = JSON.parse(this.props.DashBoardValueOf).find(item=>parseInt(item.DashBaord) === 2)
        if(ModuleValue.Value > 2 && ModuleValue.Value !== 5){
            return 2
        }else{
            return 1
        }
    }
    catch(error){return 1}
    }
     formatNumber=(number)=>{
        const _ValueOF = this.getDashBoardValueOf()
				console.log(this.props.Flags, 'flagsgsgsg')
        return NumberFormat(number, _ValueOF === 2?'total':this.props.Flags?.DashboardRoundoff === 0 ? 'standard' : 'compact', _ValueOF === 2?'default':'auto', 0)
    }
    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root} style={{ width: '90%',overflowY: "auto", height: this.props.height > 1 ? this.props.height : 300 }}>
                   {
                     this.state.done === false?
                     <div style={{display: "flex",flexFlow: "column",width: "95%"}}>
                     <div><Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/></div>
                     <div><Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/></div>
                     <div><Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/></div>
                     <div><Skeleton variant="rectangular" height={30} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/></div>
                     </div>
                     :
            <Table>
                <TableBody>
                    {
                    isEmpty(this.props.VunnenListP)?"":
                    this.props.VunnenListP.map(n => {
                        return (
                            <StyledTableRow key={n.id}>
                                <TableCell align="left" style={{ paddingTop: '5px', paddingBottom: '5px', color: 'white', borderBottom: 'none', fontSize:16 }}>
                                    {n.name}
                                </TableCell>
                                <TableCell align="right" style={{ paddingTop: '5px', paddingBottom: '5px', color: 'white', borderBottom: 'none', fontSize:16 }}>
                                    {this.formatNumber(n.value)}
                                    {
                                       parseInt(this.props.authUser.user_canSeeTB1)===1?
                                       <>/<small>({this.formatNumber(n.value2)})</small></>
                                       :"" 
                                    }
                                </TableCell>
                            </StyledTableRow>
                        );
                    })}
                </TableBody>
            </Table>
              }
        </div>
        );
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(withStyles(useStyles)(OpportunityTable));
